import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, CircularProgress, Typography } from "@material-ui/core";

const ReportStatus = ({ progressId }) => {
  const [status, setStatus] = useState("Obteniendo el estado del reporte...");
  const [progress, setProgress] = useState(0);
  const [fileUrl, setFileUrl] = useState(null);
  const token = localStorage.getItem("userToken");

  useEffect(() => {
    const fetchReportStatus = () => {
      axios
        .get(`/report/progress/${progressId}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
          const { status, progress, file_url } = response.data;
          setStatus(status);
          setProgress(progress);
          setFileUrl(file_url || null);
        })
        .catch(error => {
          console.error("Error al obtener el estado del reporte:", error);
          setStatus("Error al obtener el estado del reporte");
        });
    };

    const intervalId = setInterval(fetchReportStatus, 5000);

    return () => clearInterval(intervalId);
  }, [progressId, token]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <Typography variant="h6">{status}</Typography>
      {fileUrl ? (
        <Button
          variant="contained"
          color="primary"
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: "20px" }}
        >
          Descargar Reporte
        </Button>
      ) : (
        <div style={{ marginTop: "20px" }}>
          <CircularProgress variant="determinate" value={progress} />
          <Typography variant="body2" style={{ marginTop: "10px" }}>
            Progreso: {progress}%
          </Typography>
        </div>
      )}
    </div>
  );
};

export default ReportStatus;
